import React from 'react';
import { Text } from '@catalogo/theme-text';
import { withRouter } from 'react-router';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';
import { ModalLink } from '../styles';

export const FreightMoreOptions = ({ history }) => (
  <ModalLink onClick={replaceUrlParams(history, '#modal-more-freight-options', false)}>
    <Text>mais formas de entrega</Text>
  </ModalLink>
);

export default withRouter(FreightMoreOptions);
